<template>
  <van-overlay :show="visible" @click="clickClose">
    <div class="popup" @click.stop>
      <div class="main-bg">
        <div class="content-bg">
          <img
            v-if="isFebruaryActivity(createTime) == true"
            src="../../assets/img/my-redpack/my_open_redpack_bg_2.png"
            alt="" />
          <img
            v-else
            src="../../assets/img/my-redpack/my_open_redpack_bg.png"
            alt="" />
          <div v-if="!isFebruaryActivity(createTime)" class="title">
            新年快乐，大吉大利
          </div>
          <div class="open-bg" @click="clickOpen">開</div>
        </div>
        <van-icon
          class="icon"
          @click="clickClose"
          name="close"
          size="40"
          color="rgb(199, 154, 85)"></van-icon>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Icon, Overlay } from "vant"
export default {
  name: "redenvelopePop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    createTime: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {}
  },
  methods: {
    isFebruaryActivity(createTime) {
      if (createTime) {
        if (
          this.dateFormat(createTime, "YYYY") == "2023" &&
          this.dateFormat(createTime, "MM") == "02"
        ) {
          return true
        }
      }
      return false
    },
    clickClose() {
      this.$emit("update:visible", false)
      this.$emit("onCloseClick")
    },
    clickOpen() {
      this.$emit("onOpenClick")
    }
  }
}
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 100;
}
.popup {
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .main-bg {
    width: calc(100% - 50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .content-bg {
      position: relative;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .title {
        position: absolute;
        text-align: center;
        top: 22%;
        left: 0;
        width: 100%;
        color: rgb(223, 201, 166);
        font-size: 30px;
        font-weight: 900;
        text-shadow: 2px 2px 5px rgb(189, 150, 136);
      }
      .open-bg {
        position: absolute;
        height: 100px;
        width: 100px;
        line-height: 100px;
        border-radius: 50px;
        background-color: rgb(220, 185, 131);
        text-align: center;
        left: calc(50% - 50px);
        bottom: 50px;
        font-size: 35px;
        // font-weight: 500;
        -moz-box-shadow: 2px 2px 5px rgb(55, 55, 55);
        -webkit-box-shadow: 2px 2px 5px rgb(55, 55, 55);
        box-shadow: 2px 2px 10px rgb(55, 55, 55);
      }
    }
    .icon {
      margin-top: 15px;
    }
  }
}
</style>